<template>
  <v-dialog
      transition="dialog-top-transition"
      v-model="showModal"
      width="auto"
      :content-class="type"
      no-click-animation="false"
    >
      <v-card
        class="new-layout-modal"
      >
        <div class="title">
          {{ isEdit ? $t('productLayerList.newLayoutModal.titles.edit') : $t('productLayerList.newLayoutModal.titles.create') }}
        </div>
        <div class="content">
          <v-text-field variant="outlined" :label="$t('productLayerList.newLayoutModal.inputLabel')" v-model="layerAttrs.name"></v-text-field>
          <v-select
            v-if="loggedInUser.role == 0 && !this.isEdit"
            :label="$t('productLayerList.newLayoutModal.partnerLabel')"
            :items="partners"
            item-title="par_name"
            item-value="id"
            v-model="layerAttrs.partnerId"
          ></v-select>
          <div class="btn-row">
            <v-btn @click="closeModal"> {{ $t('productLayerList.newLayoutModal.buttons.cancel') }} </v-btn>
            <v-btn color="primary" @click="saveLayout"> {{ $t('productLayerList.newLayoutModal.buttons.save') }} </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'NewLayoutModal',
  props: {
    showModalProp: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    currentLayer: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      showModal: false,
      partners: [],
      layerAttrs: {
        name: undefined,
        partnerId: undefined,
      }
    }
  },
  mounted() {
    if (this.loggedInUser.role == 0) {
      this.getPartners();
    }
  },
  methods: {
    ...mapActions({
      getPartnersForLayouts: 'productLayout/getPartnersForLayouts',
    }),
    handleClickOutside() {
      if (document.activeElement.tagName != "INPUT") {
        this.$emit("closeModal");
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    getPartners() {
      this.getPartnersForLayouts()
        .then((res) => {
          this.partners = res;
        })
        .catch((err) => {
          console.error(err);
        })
    },
    saveLayout() {
      this.$emit('saveLayout', this.isEdit,  this.layerAttrs);
      this.$emit('closeModal');
    },
  },
  computed: {
    ...mapGetters({
      loggedInUser: "users/loggedInUser",
    })
  },
  watch: {
    showModalProp() {
      if (this.currentLayer) {
        this.layerAttrs.name = this.currentLayer.title;
      }
      this.showModal =  this.showModalProp;
    },
    showModal() {
      if (this.showModal == false) {
        this.$emit('closeModal');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-layout-modal {
  width: 320px;
  padding: 16px;
  .title {
    text-align: center;
    margin-bottom: 16px;
    font-size: 22px;
    font-weight: 550;
  }
  .content {
    .btn-row {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>